import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
const CSVFileAdapterFieldSet = ({ config, handleFormEvent, validationState, validationMessage }) => {
  const { t } = useTranslation("lookup_tables");
  const valueLabel = config.multi_value_lookup ? t("adapter_fields.value_columns") : t("adapter_fields.value_column");
  const valueHelp = config.multi_value_lookup ? t("csv_adapter.value_columns_help") : t("csv_adapter.value_column_help");
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "path",
      name: "path",
      label: t("csv_adapter.file_path"),
      autoFocus: true,
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("path", t("csv_adapter.file_path_help")),
      bsStyle: validationState("path"),
      value: config.path,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "check_interval",
      name: "check_interval",
      label: t("adapter_fields.check_interval"),
      required: true,
      onChange: handleFormEvent,
      help: t("csv_adapter.check_interval_help"),
      value: config.check_interval,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "separator",
      name: "separator",
      label: t("adapter_fields.separator"),
      required: true,
      onChange: handleFormEvent,
      help: t("csv_adapter.separator_help"),
      value: config.separator,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "quotechar",
      name: "quotechar",
      label: t("adapter_fields.quote_character"),
      required: true,
      onChange: handleFormEvent,
      help: t("adapter_fields.quote_help"),
      value: config.quotechar,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "key_column",
      name: "key_column",
      label: t("adapter_fields.key_column"),
      required: true,
      onChange: handleFormEvent,
      help: t("csv_adapter.key_column_help"),
      value: config.key_column,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "value_column",
      name: "value_column",
      label: valueLabel,
      required: !config.multi_value_lookup,
      onChange: handleFormEvent,
      help: valueHelp,
      value: config.value_column,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "multi_value_lookup",
      name: "multi_value_lookup",
      label: t("adapter_fields.multi_value_lookup"),
      checked: config.multi_value_lookup,
      onChange: handleFormEvent,
      help: t("csv_adapter.multi_value_help"),
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "case_insensitive_lookup",
      name: "case_insensitive_lookup",
      label: t("adapter_fields.case_insensitive_label"),
      checked: config.case_insensitive_lookup,
      onChange: handleFormEvent,
      help: t("adapter_fields.case_insensitive_help"),
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "cidr_lookup",
      name: "cidr_lookup",
      label: t("adapter_fields.cidr_lookup"),
      checked: config.cidr_lookup,
      onChange: handleFormEvent,
      help: t("csv_adapter.cidr_help"),
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ));
};
export default CSVFileAdapterFieldSet;
